import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './confirm-dialog.module.scss';

interface IConfirmDialogProps {
  message: string;
  onConfirm: (result: boolean) => void;
  onClose: () => void;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmDialog: React.FC<IConfirmDialogProps> = ({
  message,
  onConfirm,
  onClose,
  confirmText = 'Да',
  cancelText = 'Нет',
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  const handleConfirm = (result: boolean) => {
    setIsClosing(true);
    setTimeout(() => {
      onConfirm(result);
      onClose();
    }, 300);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setIsClosing(true);
      setTimeout(onClose, 300);
    }
  };

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div
        className={`${styles.dialog} ${
          isVisible && !isClosing ? styles.dialog_visible : styles.dialog_hidden
        }`}
      >
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button
            className={`${styles.button} ${styles.button_no}`}
            onClick={() => handleConfirm(false)}
          >
            {cancelText}
          </button>
          <button
            className={`${styles.button} ${styles.button_yes}`}
            onClick={() => handleConfirm(true)}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
